const firebaseConfig = {
    apiKey: "AIzaSyAyETD4CmIZlYoUB-f4tMDJJL83EJ94urU",
    authDomain: "ema-john-simple-b33ed.firebaseapp.com",
    databaseURL: "https://ema-john-simple-b33ed.firebaseio.com",
    projectId: "ema-john-simple-b33ed",
    storageBucket: "ema-john-simple-b33ed.appspot.com",
    messagingSenderId: "433087644665",
    appId: "1:433087644665:web:9e32535f354e0360aa3328"
  };

export default firebaseConfig;